import $ from "jquery";

export function hamburger() {
  //var siteHeader = "var(--site-header-height)";
  /* Hamburger */

  //on scroll change main-navigation-wrapper height
  $(window).scroll(function () {
    //set timeout
    var siteHeader = $(".site-header").height();
    $(".main-n1avigation-wrapper").css("top", siteHeader + "px");
  });

  $(".site-header__hamburger-cta").click(function () {
    //var siteHeader = $(".site-header").height();
    //$(".main-navigation-wrapper").css("top", siteHeader + "px"); siehe oben

    $(this).toggleClass("is-active");
    $(".main-navigation-wrapper").toggleClass(
      "main-navigation-wrapper--active"
    );
    //.toggleClass("main-navigation-wrapper--active").slideToggle(280, "swing");
    //$(".site-header__navigation").slideToggle();
    $("body").toggleClass("nav-active");
  });
}
